export default "__VITE_ASSET__0bbdc060__"